(() => {
function $ce6a18b12420bce7$export$7fd17f34fe72f4b0() {
    const loading = document.querySelector(".loading-wrapper");
    if (!loading) return;
    const logo = loading.querySelector(".loading_logo");
    const logoCircle = logo.querySelector("circle");
    const logoPath = logo.querySelector("path");
    gsap.set(logoCircle, {
        drawSVG: "0 100% live"
    });
    gsap.set(logoPath, {
        drawSVG: "0 100% live"
    });
    gsap.to(logoCircle, {
        drawSVG: "100% 100% live",
        duration: 1,
        ease: "expo.out"
    });
    gsap.to(logoPath, {
        drawSVG: "100% 100% live",
        duration: 1,
        ease: "expo.out"
    });
    gsap.to(loading, {
        maskPosition: "100% 100%",
        duration: 1,
        delay: 0.5,
        ease: "expo.out",
        onComplete: ()=>{
            loading.style.display = "none";
            gsap.set(logoCircle, {
                drawSVG: "0% 0% live"
            });
            gsap.set(logoPath, {
                drawSVG: "0% 0% live"
            });
            gsap.set(loading, {
                maskPosition: "0% 100%"
            });
        }
    });
    // Loading animation
    const links = document.querySelectorAll("a");
    links.forEach((l)=>{
        l.addEventListener("click", (e)=>{
            // e.preventDefault();
            const href = l.href;
            const url = new URL(href);
            if (window.location.origin === url.origin && window.location.pathname !== url.pathname && l.target !== "_blank") {
                e.preventDefault();
                loading.style.display = "block";
                gsap.to(logoCircle, {
                    drawSVG: "0% 100% live",
                    duration: 0.5,
                    delay: 0.5,
                    ease: "expo.out"
                });
                gsap.to(logoPath, {
                    drawSVG: "0% 100% live",
                    duration: 0.5,
                    delay: 0.5,
                    ease: "expo.out"
                });
                gsap.to(loading, {
                    maskPosition: "50% 100%",
                    duration: 1,
                    ease: "expo.out",
                    onComplete: ()=>{
                        window.location.href = href;
                    }
                });
            // setTimeout(() => {
            //   window.location.href = href;
            // }, 500);
            }
        });
    });
}


// Link timelines to scroll position
function $719658c63b791dcb$export$48ba2fbf80d9a7d(el, triggerEl, start, end, delay, withScroll) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("reveal-heading_wrapper");
    el.parentNode.insertBefore(wrapper, el);
    const transparent = el.cloneNode(true);
    wrapper.appendChild(el);
    wrapper.appendChild(transparent);
    transparent.classList.add('transparent');
    // transparent.removeAttribute('revealHeading');
    gsap.set(el, {
        opacity: 0
    });
    gsap.set(transparent, {
        backgroundPositionX: "0%"
    });
    const trigger = {
        trigger: triggerEl,
        scrub: true,
        once: true,
        start: start,
        fastScrollEnd: 500,
        preventOverlaps: "scroll-headings"
    };
    if (!withScroll) {
        const tl = gsap.timeline({
            paused: true
        });
        trigger.onEnter = ()=>{
            tl.to(transparent, {
                backgroundPositionX: "50%",
                delay: delay,
                duration: 0.5,
                overwrite: "auto",
                ease: "expo.out",
                onComplete: ()=>{
                    gsap.set(el, {
                        opacity: 1
                    });
                }
            }).to(transparent, {
                backgroundPositionX: "100%",
                duration: 0.5,
                overwrite: "auto",
                ease: "expo.out",
                onComplete: ()=>{
                    transparent.remove();
                }
            });
            tl.play();
        };
        gsap.timeline({
            scrollTrigger: trigger
        });
    } else {
        trigger.end = end;
        gsap.timeline({
            scrollTrigger: trigger
        }).to(transparent, {
            backgroundPositionX: "50%",
            delay: delay,
            duration: 0.3,
            overwrite: "auto",
            ease: "expo.out",
            onComplete: ()=>{
                gsap.set(el, {
                    opacity: 1
                });
            }
        }).to(transparent, {
            backgroundPositionX: "100%",
            duration: 0.3,
            overwrite: "auto",
            ease: "expo.out",
            onComplete: ()=>{
                transparent.remove();
            }
        });
    }
}
function $719658c63b791dcb$export$f8b3d1cda34ef9a8() {
    const blocks = document.querySelectorAll("[reveal-heading]");
    blocks.forEach((el)=>{
        el.classList.add('init');
        const startVal = el.dataset.startPos || "center bottom", endVal = el.dataset.endPos || "bottom center", delay = el.dataset.delay || 0.2, withScrollTrigger = el.dataset.withScroll || false;
        $719658c63b791dcb$export$48ba2fbf80d9a7d(el, el, startVal, endVal, delay, withScrollTrigger);
    });
}


// Link timelines to scroll position
function $1aa2e0393d0f1beb$var$createScrollTrigger(triggerElement, elements, start, end, stagger, delay, withScroll) {
    const trigger = {
        trigger: triggerElement,
        scrub: true,
        start: start,
        fastScrollEnd: 500,
        preventOverlaps: "scroll-text"
    };
    if (!withScroll) {
        trigger.onEnter = ()=>{
            gsap.to(elements, {
                yPercent: 0,
                stagger: stagger,
                ease: "power4.out",
                delay: Number(delay)
            });
        };
        return gsap.timeline({
            scrollTrigger: trigger
        });
    } else {
        trigger.end = end;
        return gsap.timeline({
            scrollTrigger: trigger
        }).to(words, {
            yPercent: 0,
            stagger: stagger,
            ease: "none"
        });
    }
}
function $1aa2e0393d0f1beb$export$1601281ad392a6d8() {
    // Split all words on the brand core section
    const textEls = document.querySelectorAll('[stagger-text]');
    textEls.forEach((el)=>{
        el.classList.add("init");
        const startVal = el.dataset.startPos || "center bottom", endVal = el.dataset.endPos || "bottom center", stagger = el.dataset.stagger || 0.05, delay = el.dataset.delay || 0, withScrollTrigger = el.dataset.withScroll || false;
        if (el.classList.contains('w-richtext')) {
            const staggerTextEls = SplitText.create(el.querySelectorAll("p, li, h2, h3"), {
                type: "lines",
                mask: "lines",
                autoSplit: true,
                onSplit: (self)=>{
                    gsap.set(self.lines, {
                        yPercent: 100
                    });
                    return $1aa2e0393d0f1beb$var$createScrollTrigger(el, self.lines, startVal, endVal, stagger, delay, withScrollTrigger);
                }
            });
        } else {
            const staggerTextEls = SplitText.create(el, {
                type: "lines",
                mask: "lines",
                autoSplit: true,
                onSplit: (self)=>{
                    gsap.set(self.lines, {
                        yPercent: 100
                    });
                    return $1aa2e0393d0f1beb$var$createScrollTrigger(el, self.lines, startVal, endVal, stagger, delay, withScrollTrigger);
                }
            });
        }
    });
}


// Link timelines to scroll position
function $4013e65a83b1b778$var$createScrollList(triggerElement, elements, start, stagger, delay) {
    gsap.set(elements, {
        yPercent: 100,
        opacity: 0
    });
    gsap.timeline({
        scrollTrigger: {
            trigger: triggerElement,
            scrub: true,
            start: start,
            onEnter: ()=>{
                gsap.to(elements, {
                    yPercent: 0,
                    opacity: 1,
                    stagger: stagger,
                    ease: "power4.out",
                    delay: Number(delay)
                });
            }
        }
    });
}
function $4013e65a83b1b778$export$9b05384e3b3cbff1() {
    const list = document.querySelectorAll("[stagger-list]");
    if (!list) return;
    list.forEach((el)=>{
        const elements = el.querySelectorAll("[stagger-el]"), startVal = el.dataset.startPos || "top bottom", stagger = el.dataset.stagger || 0.05, delay = el.dataset.delay || 0;
        if (!elements) return;
        $4013e65a83b1b778$var$createScrollList(el, elements, startVal, stagger, delay);
    });
}


function $8dde7174b81b4982$export$1744cb1794fd120a() {
    const buttons = document.querySelectorAll('.button');
    buttons.forEach((button)=>{
        // if button doesn't include a .button_icon, return
        if (!button.querySelectorAll('.button_icon')) return;
        // use GSAP + DrawSVG plugin to animate the button icon path with mouse hover
        const icon = button.querySelectorAll('.button_icon');
        const isVertical = button.classList.contains('animate-vertical');
        const isReverse = button.classList.contains('animate-reverse');
        button.addEventListener('mouseenter', ()=>{
            if (isVertical) gsap.to(icon, {
                duration: 0.5,
                y: "100%",
                ease: 'expo.out'
            });
            else if (isReverse) gsap.to(icon, {
                duration: 0.5,
                x: "-100%",
                ease: 'expo.out'
            });
            else gsap.to(icon, {
                duration: 0.5,
                x: "100%",
                ease: 'expo.out'
            });
        });
        button.addEventListener('mouseleave', ()=>{
            if (isVertical) gsap.to(icon, {
                duration: 0.5,
                y: "0%",
                ease: 'expo.out'
            });
            else if (isReverse) gsap.to(icon, {
                duration: 0.5,
                x: "0%",
                ease: 'expo.out'
            });
            else gsap.to(icon, {
                duration: 0.5,
                x: "0%",
                ease: 'expo.out'
            });
        });
    });
}


function $ee20a49b40292314$export$22ea07d0c2ddb570() {
    // apply a ".is-active" class to the ".navbar_component" element if the user has scrolled past the top of the page,
    // otherwise remove the ".is-active" class. Also, apply a ".is-active" class to the ".navbar_component" element if the user
    // clicks on any elements with the ".navbar_link.is-dropdown" class, otherwise remove the ".is-active" class.
    const navbar = document.querySelector(".navbar_component");
    const dropdowns = document.querySelectorAll(".navbar_link.is-dropdown");
    const mobileTrigger = document.querySelector(".navbar_mobile-trigger");
    const mobileMenu = document.querySelector(".navbar_menu");
    let isScrolling = false;
    window.addEventListener("scroll", ()=>{
        if (!isScrolling) window.requestAnimationFrame(()=>{
            isDropdownOpen();
            isScrolling = false;
        });
        isScrolling = true;
    });
    isDropdownOpen();
    let currentDropdown = null;
    // checks if there's any dropdown open, and if so, keeps the navbar active. Otherwise, removes the active class
    function isDropdownOpen() {
        const isOpen = Array.from(dropdowns).some((dropdown)=>dropdown.classList.contains("is-active"));
        // only remove the active class if the user has not scrolled to the top of the page, none of the dropdowns are open, and the mobile menu is not open
        if (!isOpen && window.scrollY === 0 && !mobileMenu.classList.contains("is-active")) navbar.classList.remove("is-active");
        else navbar.classList.add("is-active");
    }
    const dropdownsTimelines = [];
    dropdowns.forEach((dropdown, i)=>{
        const submenu = dropdown.nextElementSibling;
        const icon = dropdown.querySelector(".navbar_link-icon");
        if (!submenu) return;
        // create a timeline for each submenu. Execute the isDropdownOpen function if the submenu timeline is reversed, once it's completed.
        const submenuTl = gsap.timeline({
            paused: true,
            onStart: isDropdownOpen,
            onReverseComplete: isDropdownOpen
        });
        submenuTl.fromTo(submenu, {
            height: 0
        }, {
            height: "auto",
            duration: 0.5,
            ease: "expo.inOut"
        });
        if (icon) submenuTl.to(icon, {
            rotate: -180,
            duration: 0.5,
            ease: "expo.inOut"
        }, 0);
        if (submenu.querySelector(".big-links_list")) submenuTl.from(submenu.querySelectorAll(".big-links_list a"), {
            yPercent: 10,
            opacity: 0,
            duration: 0.2,
            stagger: 0.1
        }, 0);
        dropdownsTimelines.push(submenuTl);
        // closes all submenus (playing their respective timelines) and opens the submenu that was clicked
        function toggleSubmenu() {
            if (currentDropdown && currentDropdown !== dropdown) {
                dropdownsTimelines.forEach((timeline)=>timeline.reverse());
                currentDropdown.classList.remove("is-active");
            }
            if (submenuTl.progress() === 1) submenuTl.reverse();
            else submenuTl.play();
            if (currentDropdown === dropdown) {
                currentDropdown.classList.remove("is-active");
                currentDropdown = null;
            } else {
                currentDropdown = dropdown;
                currentDropdown.classList.add("is-active");
            }
        }
        dropdown.addEventListener("click", toggleSubmenu);
    });
    // close the submenu if the user clicks outside of the navbar
    document.addEventListener("click", (e)=>{
        if (!navbar.contains(e.target)) {
            dropdownsTimelines.forEach((timeline)=>timeline.reverse());
            currentDropdown?.classList.remove("is-active");
            currentDropdown = null;
        }
    });
    //if browser is mobile (max-width: 991px), add logic to make the .navbar_mobile-trigger element toggle the .is-active class on the .navbar_menu element.
    // Use GSAP to also animate the .navbar_menu element height from 0 to auto when the .is-active class is added, and from auto to 0 when the .is-active class is removed.
    //set gsap.matchMedia instance to detect mobile breakpoint
    const mm = gsap.matchMedia();
    mm.add({
        small: "(max-width: 991px)"
    }, (ctx)=>{
        if (ctx.conditions.small) initializeMobileMenu();
    });
    function initializeMobileMenu() {
        // To calculate the max-height of the mobile menu, we need to get the .navbar_component and subtract from the window.innerHeight
        const navbarHeight = navbar.offsetHeight;
        // set the navbar height as a CSS variable
        document.documentElement.style.setProperty("--navbar-height", `${navbarHeight}px`);
        if (mobileTrigger && mobileMenu) {
            const pathOpen = mobileTrigger.querySelectorAll(".menu-path-open");
            const pathClose = mobileTrigger.querySelectorAll(".menu-path-close");
            const triggerLabels = mobileTrigger.querySelectorAll(".navbar_mobile-trigger-label");
            gsap.set(pathClose, {
                drawSVG: "0% 0%"
            });
            gsap.set(pathOpen, {
                drawSVG: "0% 100%"
            });
            const mobileMenuTl = gsap.timeline({
                paused: true
            });
            mobileMenuTl.to(pathOpen, {
                drawSVG: "100% 100%",
                duration: 0.3,
                stagger: 0.1,
                ease: "expo.inOut"
            }).to(pathClose, {
                drawSVG: "100% 0%",
                duration: 0.5,
                ease: "expo.inOut"
            });
            mobileMenuTl.to(triggerLabels, {
                yPercent: -100,
                duration: 0.3,
                stagger: 0.1,
                ease: "expo.inOut"
            }, 0);
            mobileTrigger.addEventListener("click", ()=>{
                mobileMenu.classList.toggle("is-active");
                gsap.to(mobileMenu, {
                    height: mobileMenu.classList.contains("is-active") ? "auto" : 0,
                    duration: 0.5,
                    ease: "expo.inOut"
                });
                if (mobileMenu.classList.contains("is-active")) mobileMenuTl.play();
                else mobileMenuTl.reverse();
            });
        }
        // close the mobile menu if the user clicks outside of it
        document.addEventListener("click", (e)=>{
            if (!navbar.contains(e.target)) {
                mobileMenu.classList.remove("is-active");
                gsap.to(mobileMenu, {
                    height: 0,
                    duration: 0.5,
                    ease: "expo.inOut"
                });
            }
        });
        // add the .is-active class to the .navbar_component element if .navbar_mobile-trigger is clicked and the scroll position is at the top of the page
        mobileTrigger.addEventListener("click", ()=>{
            if (window.scrollY === 0) navbar.classList.toggle("is-active");
        });
    }
}


function $83ae171d5a192456$export$e125e88f659d8ab1() {
    const paths = document.querySelectorAll("[path-animation]");
    if (!paths) return;
    // set svg path animation using GSAP, ScrollTrigger and DrawSVG plugins
    paths.forEach((path)=>{
        const tl = gsap.timeline({
            paused: true,
            defaults: {
                duration: 1,
                ease: "expo.inOut"
            }
        });
        tl.fromTo(path.querySelector("path"), {
            drawSVG: "0%"
        }, {
            drawSVG: "100%"
        });
        ScrollTrigger.create({
            trigger: path,
            start: "top center",
            animation: tl,
            toggleActions: "play none none none"
        });
    });
}


function $b140b9eb34f1ac44$export$4bc49541bd3cd0fc() {
    const forms = document.querySelectorAll("form");
    if (!forms) return;
    forms.forEach((form)=>{
        const formSubmitButton = form.querySelector(".button.is-submit");
        const submitButton = form.querySelector(".form_submit");
        const label = form.querySelector(".button_label-inner");
        if (!formSubmitButton || !submitButton) return;
        // add event listener to the form submit button
        formSubmitButton.addEventListener("click", function(e) {
            e.preventDefault(); // prevent the default action
            // check if the form is valid
            if (form.checkValidity()) {
                // if valid, submit the form and change the button text
                submitButton.click();
                label.textContent = submitButton.getAttribute("data-wait");
            } else // if not valid, report validity (this will show the HTML5 validation messages)
            form.reportValidity();
        });
        form.addEventListener("submit", function() {
            // scroll screen back to the top of the using Lenis.js scrollTo method
            const formTop = form.getBoundingClientRect().top;
            lenis.scrollTo(formTop, 500);
        });
    });
}


function $0cd6a27b99afe986$export$568421ea5e873446() {
    const items = document.querySelectorAll(".video-player-full");
    if (!items) return;
    items.forEach((item)=>{
        const trigger = item.querySelector(".video-player-full_trigger"), modal = item.querySelector(".video-player-full_modal");
        if (!trigger || !modal) return;
        const close = modal.querySelector(".video-player-full_modal-close");
        const tl = $0cd6a27b99afe986$var$setVideoModal(modal);
        let player;
        if (typeof Vimeo !== "undefined") {
            player = new Vimeo.Player(modal.querySelector('iframe'));
            tl.eventCallback("onComplete", ()=>{
                player.play();
            });
            tl.eventCallback("onReverseComplete", ()=>{
                player.setCurrentTime(0);
            });
        }
        trigger.addEventListener("click", ()=>{
            $0cd6a27b99afe986$var$openModal(tl);
        });
        close.addEventListener("click", ()=>{
            if (player) player.pause();
            $0cd6a27b99afe986$var$closeModal(tl);
        });
    });
}
function $0cd6a27b99afe986$var$setVideoModal(modal) {
    videoPlayer = modal.querySelector(".video-player-full_modal-inner"), videoClose = modal.querySelector(".video-player-full_modal-close");
    gsap.set(modal, {
        visibility: "hidden",
        maskPosition: "0% 0%"
    });
    gsap.set(videoClose, {
        y: "-10rem"
    });
    const tl = gsap.timeline({
        paused: true
    });
    tl.to(modal, {
        maskPosition: "100% 0%",
        visibility: "visible",
        duration: 1,
        ease: "expo.inOut"
    }, 0).to(videoClose, {
        y: "0rem",
        duration: 1,
        ease: "expo.inOut"
    }, 0.2);
    return tl;
}
async function $0cd6a27b99afe986$var$openModal(tl) {
    tl.play();
}
function $0cd6a27b99afe986$var$closeModal(tl) {
    tl.reverse();
}


window.addEventListener("beforeunload", ()=>{
    console.log("beforeunload");
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
});
window.addEventListener("popstate", ()=>{
    console.log("popstate");
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
});
document.addEventListener("pageshow", (event)=>{
    console.log("pageshow", event);
    // Check if the page was restored from the bfcache
    if (event.persisted) // Re-run your loading animation
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
});
// wait until DOM is ready (html and svg markup)
document.addEventListener("DOMContentLoaded", function() {
    (0, $ee20a49b40292314$export$22ea07d0c2ddb570)();
    (0, $8dde7174b81b4982$export$1744cb1794fd120a)();
    (0, $4013e65a83b1b778$export$9b05384e3b3cbff1)();
    (0, $83ae171d5a192456$export$e125e88f659d8ab1)();
    (0, $b140b9eb34f1ac44$export$4bc49541bd3cd0fc)();
    (0, $0cd6a27b99afe986$export$568421ea5e873446)();
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
});
document.fonts.ready.then(()=>{
    (0, $1aa2e0393d0f1beb$export$1601281ad392a6d8)();
    (0, $719658c63b791dcb$export$f8b3d1cda34ef9a8)();
});

})();
//# sourceMappingURL=globals.js.map
